import { useEffect, useRef, useState } from 'react';
import { Form as FinalForm } from 'react-final-form';

import { injectIntl } from '../../util/reactIntl';
import { FieldReactSelect, Form } from '../../components';

import css from './DirectoryPage.module.css';

const identity = v => v;

function DeafUserVideoForm(props) {
  return (
    <FinalForm
      {...props}
      render={renderProps => {
        const {
          handleSubmit,
          form,
          values,
          inProgress,
          updateError,
          pristine,
          outOfHours,
          signaliseLocations,
          intl,
        } = renderProps;

        const selectRef = useRef(null);
        const [open, setOpen] = useState(false);
        const [inputValue, setInputValue] = useState('');

        useEffect(() => {
          if (values.reset) {
            form.change('GpName', undefined);
            form.change('GpAddress', undefined);
          }
        }, [values.reset]);

        const submitDisabled =
          !values?.addressLocation ||
          (values.addressLocation.value == 9999
            ? !values.GpName ||
              !values.GpAddress ||
              !values.GpAddress.search ||
              !values.GpAddress.selectedPlace ||
              !values.GpAddress.selectedPlace.address ||
              !values.GpAddress.selectedPlace.origin
            : !values?.addressLocation?.address?.place) ||
          outOfHours;

        const addressRequiredMessage = intl.formatMessage({
          id: 'AddressDetailsForm.addressRequired',
        });
        const addressNotRecognisedMessage = intl.formatMessage({
          id: 'AddressDetailsForm.addressNotRecognised',
        });

        const subject = 'New GP';
        const body = [
          'Hello Signalise Team,',
          '',
          'I would like to call my doctor but I cannot find them in the list.',
          '',
          'The name of my GP is: ADD YOUR GP NAME',
          '',
          'The address of my GP is (if you know it) is: ADD YOUR GP ADDRESS',
          '',
          'Thank you',
          '',
          'ADD YOUR NAME',
        ].join('\r\n');

        const href = `mailto:hello@signalise.coop?subject=${encodeURIComponent(
          subject
        )}&body=${encodeURIComponent(body)}`;

        return (
          <Form className={css.form} onSubmit={handleSubmit}>
            {updateError && <div className={css.error}>{updateError}</div>}
            <div className={css.doctorForm}>
              <FieldReactSelect
                id={'addressLocations'}
                name="addressLocation"
                options={signaliseLocations}
                className={css.locations}
                autoComplete="addressLocation"
                label={'Choose your doctor:'}
                defaultValue={null}
                placeholder={'Please select the organisation to call'}
                isSearchable={true}
                isClearable={true}
                selectRef={value => {
                  selectRef.current = value;
                }}
                noOptionsMessage={() => (
                  <button
                    type="button"
                    style={{
                      width: '100%',
                      display: 'block',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      form.batch(() => {
                        form.change('reset', true);
                        form.change('addressLocation', {
                          key: 9999,
                          value: 9999,
                          label: "I can't find my doctor",
                        });
                      });
                      setOpen(false);
                      setInputValue('');
                      selectRef.current.blur();
                    }}
                    menuIsOpen={open}
                    onInputChange={inputValue => setInputValue(inputValue)}
                    inputValue={inputValue}
                    onFocus={() => {
                      setOpen(true);
                    }}
                    onBlur={() => setOpen(false)}
                    blurInputOnSelect
                  >
                    I can't find my doctor
                  </button>
                )}
                filterOption={(option, searchText) => {
                  const optionValue = option.value;
                  const optionLabel = option.label;
                  const results = optionLabel.toLowerCase().indexOf(searchText.toLowerCase()) != -1;
                  // if (optionLabel.indexOf("can't") != -1) return false;
                  if (optionValue == 9999) return false;
                  if (results) return true;
                }}
              />
              <button className={css.doctorButton} disabled={submitDisabled} type="submit">
                Start Call
              </button>
            </div>

            {values?.addressLocation?.key == 9999 && (
              <>
                <p>
                  We cannot call your doctor as they do not have a contract. Let us know who they
                  are below and also <a href={href}>Click to email Signalise</a>
                </p>
              </>
            )}
            {outOfHours ? (
              <p className={css.outOfHoursMessage}>
                Opening hours are between 8:00 and 18:30, Monday to Friday excluding Bank Holidays.
                Please come back between these hours to make a call.
              </p>
            ) : null}
          </Form>
        );
      }}
    />
  );
}

export default injectIntl(DeafUserVideoForm);
